<template>
    <v-app>
        <!--<Header/>-->
        <!--<keep-alive>-->
        <!--<transition name="fade" mode="out-in">-->
        <router-view /> 
        <!--</transition>-->
        <!--</keep-alive>-->
        <Footer/>
    </v-app>
</template>

<script>
import { settingsMixin } from '@/utils/settings-mixin';
import { layoutMixin } from '@/utils/layout-mixin';
import Footer from '@/views/website/Footer.vue';

export default {
    mixins: [settingsMixin, layoutMixin],
    components: {
        //Header,
        Footer
    },
    data() {
        return {
            backgroundImage: 'bgImage1'
        };
    },
    computed: {},
    methods: {},
    mounted() {
        // if (!this.isTabletOrPhone) {
        // if (true) {
            this.addFixedBackgroundImageByClass(this.backgroundImage);
        // }
    },
    beforeDestroy() {
        this.removeFixedBackgroundImageByClass(this.backgroundImage);
    }
};
</script>

<style>
/*
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .15s;
}

.fade-enter-active {
  transition-delay: .15s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
*/
html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
</style>
